import React, { useEffect } from 'react';
import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';

import TopNavigation from '@cloudscape-design/components/top-navigation';
import AppLayout from '@cloudscape-design/components/app-layout';
import SideNavigation from '@cloudscape-design/components/side-navigation';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import ContentLayout from '@cloudscape-design/components/content-layout';
import { getSideNavItems } from 'src/utils/navigation';
import { getUserName } from 'src/utils/auth';
import { Mode, applyMode } from "@cloudscape-design/global-styles";

interface LayoutProps {
    children: React.ReactNode;
    breadcrumbs?: { href: string, text: string }[]
}

export const Layout: React.FC<LayoutProps> = ({
    children,
    breadcrumbs,
}) => {
    const navigate = useNavigate();

    const userPool = new CognitoUserPool({
        UserPoolId: 'us-east-1_VcwEzBc6u',
        ClientId: '7rq2g8rks630t1il6pstc8r6c2'
    });

    const logout = () => {
        const cognitoUser = new CognitoUser({
            Username: localStorage.getItem('username') ?? '',
            Pool: userPool,
        });
        cognitoUser.signOut(() => {
            localStorage.removeItem('username');
            localStorage.removeItem('accessToken');
            navigate('/login');
        });
    }

    useEffect(() => {
        applyMode(Mode.Dark);
        const username = localStorage.getItem('username');
        if (!username) {
            navigate('/login');
        }
    }, []);

    const i18nStrings = {
        searchIconAriaLabel: 'Search',
        searchDismissIconAriaLabel: 'Close search',
        overflowMenuTriggerText: 'More',
        overflowMenuTitleText: 'All',
        overflowMenuBackIconAriaLabel: 'Back',
        overflowMenuDismissIconAriaLabel: 'Close menu',
    };

    const profileActions = [
        { id: 'signout', text: 'Sign out' },
    ];

    const breadcrumbsItems = [
        {
            text: 'Home',
            href: '/',
        },
        ...(breadcrumbs ?? [])
    ];

    return (
        <div>
            <TopNavigation
                i18nStrings={i18nStrings}
                identity={{
                    href: '/',
                    title: 'KANJ Admin Portal',
                }}
                utilities={[
                    {
                        type: 'menu-dropdown',
                        text: getUserName().toLocaleUpperCase(),
                        description: getUserName(),
                        iconName: 'user-profile',
                        onItemClick: logout,
                        items: profileActions,
                    },
                ]}
            />
            <AppLayout
                stickyNotifications
                toolsHide
                navigation={<SideNavigation activeHref="#/pages" items={getSideNavItems()} />}
                breadcrumbs={<BreadcrumbGroup items={breadcrumbsItems} expandAriaLabel="Show path" ariaLabel="Breadcrumbs" />}
                content={<ContentLayout>{children}</ContentLayout>}
            />

        </div>
    );
}